<header class="container">
    <h1 class="title {{sizeClass}}" [title]="title" [innerHtml]="title | safeHtml"></h1>
    <finder-font-icon *ngIf="icon" class="icon" [name]="icon.src" [svgSrc]="icon.url" size="xl">
    </finder-font-icon>
    <div class="over-title" *ngIf="showOverTitle" [title]="overTitle" [innerHtml]="overTitle | safeHtml"></div>
</header>
